import { Component, OnInit } from '@angular/core';
import { homeRoute } from '@app-constants/app.constants';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';

@Component({
  selector: 'app-course-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css', ]
})
export class courseFooterComponent implements OnInit {
  homeRoute=homeRoute;
  constructor(
    private gaService: GAnalyticsService
  ) { }

  ngOnInit(): void {
  }

  we_socialmedia(click) {
    this.gaService.webEngageEvent({
      'event': 'Social Media',
      'Click': click,
      }) 
  };

}
